<template>
  <div>

    <div ref="getSchoolSubject" style="height:400px"></div>


    <div ref="getStudentSchoolSubject" style="height:400px;"></div>


    <div ref="getTeacherSchoolSubject" style="height:400px;"></div>

  </div>
</template>

<script>
  export default {
    data() {
      return {
        apiPath: '/api/SchoolSubject/',

        chartGetSchoolSubject: null,
        chartGetStudentSchoolSubject: null,
        chartGetTeacherSchoolSubject: null,
      };
    },
    components: {},
    created: function() {

    },
    mounted: function() {


      this.GetSchoolSubject();
      this.GetStudentSchoolSubject();
      this.GetTeacherSchoolSubject();


      window.onresize = function () {
        this.chartGetSchoolSubject.resize();
        this.chartGetStudentSchoolSubject.resize();
        this.chartGetTeacherSchoolSubject.resize();
      };

    },
    methods: {
      //校本课程分类统计--雷达图
      async GetSchoolSubject () {


        this.chartGetSchoolSubject = this.echarts.init(this.$refs.getSchoolSubject);
        let option = {
          title: {
            text: '每类校本课统计'
          },
          tooltip: {},
          legend: {
            //show:false,
            //data: ['预算分配（Allocated Budget）', '实际开销（Actual Spending）']
          },
          radar: {
            // shape: 'circle',
            radius: '70%',
            name: {
              textStyle: {
                color: '#fff',
                backgroundColor: '#999',
                borderRadius: 3,
                padding: [3, 5]
              }
            },
            indicator: [
              //{ name: '销售（sales）' },
              //{ name: '管理（Administration）' },
              //{ name: '信息技术（Information Techology）' },
              //{ name: '客服（Customer Support）' },
              //{ name: '研发（Development）' },
              //{ name: '市场（Marketing）' }
            ]
          },
          series: [{
            name: '',
            type: 'radar',
            data: [
              {
                value: [],//[4300, 10000, 28000, 35000, 50000, 19000],
                //name: '课程数量'
              },
            ]
          }]
        };

        //this.chartGetSchoolSubject.setOption(option);
        this.chartGetSchoolSubject.showLoading();

        let res = await this.xyapi.get(
          this.$store.state.apiPath + this.apiPath + 'GetSchoolSubject'
        );
        if (res.success) {
          let maxVal = 0;
          let radarIndicatorArr = [];
          let seriesDataList = [];
          res.data.forEach((item)=>{
            seriesDataList.push(item.Count);
            if (maxVal <= item.Count) {
              maxVal = item.Count;
            }
          })
          res.data.forEach((item)=>{
            radarIndicatorArr.push({ name: item.DisciplineName, max: maxVal })
          })

          option.radar.indicator = radarIndicatorArr;
          option.series[0].data[0].value = seriesDataList;

          this.chartGetSchoolSubject.hideLoading();
          this.chartGetSchoolSubject.setOption(option, true);

        } else {
          this.xy.msgError(res.msg);
          // MainVue.$Modal.error({ title: "错误信息", content: res.data.msg });
        }


      },

      //学生--柱状图
      async GetStudentSchoolSubject () {


        this.chartGetStudentSchoolSubject = this.echarts.init(this.$refs.getStudentSchoolSubject);
        let option = {
          //color: ['#3398DB'],
          title: {
            text: '每类校本课学生数'
          },
          tooltip: {
            trigger: 'axis',
            axisPointer: {            // 坐标轴指示器，坐标轴触发有效
              type: 'shadow'        // 默认为直线，可选为：'line' | 'shadow'
            }
          },
          grid: {
            left: '3%',
            right: '4%',
            bottom: '3%',
            containLabel: true
          },
          xAxis: {
            type: 'category',
            data: [],
            axisTick: {
              alignWithLabel: true
            },
            axisLabel: {
              interval: 0,
              formatter: (value)=> {
                console.log("value..." + value);
                return this.formatterEllipsis(value);
              }
            },
          },
          yAxis: [
            {
              minInterval: 1,
              type: 'value'
            }
          ],
          series: [{
            name: '男',
            type: 'bar',
            stack: '总量',
            label: {
              normal: {
                show: true,
                position: 'insideRight'
              }
            },
            data: []
          }, {
            name: '女',
            type: 'bar',
            stack: '总量',
            label: {
              normal: {
                show: true,
                position: 'insideRight'
              }
            },
            data: []
          },
          ]
        };
        this.chartGetStudentSchoolSubject.setOption(option);
        this.chartGetStudentSchoolSubject.showLoading();
        let res = await this.xyapi.get(
          this.$store.state.apiPath + this.apiPath + 'GetStudentSchoolSubject'
        );
        console.log(res)
        if (res.success) {

          let xAxisDataList = [];

          let sexFalseList = [];
          let sexTrueList = [];
          res.data.forEach((item)=>{
            //如果没有此年级,添加
            if (xAxisDataList.indexOf(item.DisciplineName) < 0) {
              xAxisDataList.push(item.DisciplineName);
            }
            if (item.SexName === "男") {
              sexTrueList.push(item.Count);
            } else {
              sexFalseList.push(item.Count);
            }

          })

          option.xAxis.data = xAxisDataList;
          option.series[0].data = sexTrueList;
          option.series[1].data = sexFalseList;

          this.chartGetStudentSchoolSubject.hideLoading();
          this.chartGetStudentSchoolSubject.setOption(option, true);

        } else {
          this.xy.msgError(res.msg);
          // MainVue.$Modal.error({ title: "错误信息", content: res.data.msg });
        }

      },

      //教师--柱状图
      async GetTeacherSchoolSubject () {

        this.chartGetTeacherSchoolSubject = this.echarts.init(this.$refs.getTeacherSchoolSubject);
        let option = {
          //color: ['#3398DB'],
          title: {
            text: '每类校本课教师数'
          },
          tooltip: {
            trigger: 'axis',
            axisPointer: {            // 坐标轴指示器，坐标轴触发有效
              type: 'shadow'        // 默认为直线，可选为：'line' | 'shadow'
            }
          },
          grid: {
            left: '3%',
            right: '4%',
            bottom: '3%',
            containLabel: true
          },
          xAxis: {
            type: 'category',
            data: [],
            axisTick: {
              alignWithLabel: true
            },
            axisLabel: {
              interval: 0,
              formatter: (value)=> {
                return this.formatterEllipsis(value);
              }
            },
          },
          yAxis: [
            {
              minInterval: 1,
              type: 'value'
            }
          ],
          series: [{
            name: '校本分类',
            type: 'bar',
            barWidth: '60%',
            data: []
          }]
        };
        //this.chartGetTeacherSchoolSubject.setOption(option);
        this.chartGetTeacherSchoolSubject.showLoading();

        let res = await this.xyapi.get(
          this.$store.state.apiPath + this.apiPath + 'GetTeacherSchoolSubject'
        );
        if (res.success) {

          let xAxisDataList = [];
          let seriesDataList = [];
          res.data.forEach((item)=>{
            xAxisDataList.push(item.DisciplineName);
            seriesDataList.push(item.Count);
          })
          option.xAxis.data = xAxisDataList;
          option.series[0].data = seriesDataList;

          this.chartGetTeacherSchoolSubject.hideLoading();
          this.chartGetTeacherSchoolSubject.setOption(option, true);

        } else {
          this.xy.msgError(res.msg);
          // MainVue.$Modal.error({ title: "错误信息", content: res.data.msg });
        }

      },
      formatterEllipsis: function () {
        var value = "";
        var maxLength = 3;//每项显示文字个数
        if (arguments.length === 1) {
          value = arguments[0];
        } else if (arguments.length === 2) {
          value = arguments[0];
          maxLength = arguments[1];
        } else {
          return "";
        }

        var valLength = value.length;//X轴类目项的文字个数
        var rowN = Math.ceil(valLength / maxLength); //类目项需要换行的行数
        if (rowN > 1)//如果类目项的文字大于3,
        {
          return value.substring(0, maxLength) + "...";
        }
        else {
          return value;
        }
      },
    }
  };
</script>
<style lang='less' >

</style>

